<template>
  <div class="home">
    <transition name="detail_slide">
      <router-view />
    </transition>

    <div v-for="container in activeContainer" :key="`container${container.id}`" :style="`
          position: absolute;
          left: calc(${(container.position ? container.position[1] : 0) * (1 / columns)} * (100vw - 20px)  + 10px);
              top: calc(${(container.position ? container.position[0] : 0) * (1 / columns)} * (100vw - 12px) + 10px);
              width: calc(${container.width * (1 / columns)} * (100vw - 20px));
              height: calc(${container.height * (1 / columns)} * (100vw - 20px));
          padding: 7px;
          transition: all 0.3s ease-in-out;
        `">
      <!-- GREETING / LOGO -->
      <div class="home-dashboard-logo" v-if="container.widget === 'logo'">
        <TText style="margin-bottom: -3%; text-align: center" value="WELCOME_BACK" font_weight="600" size="25" />
        <img v-if="$vuetify.theme.dark" style="" :width="$i18n.locale === 'en' ? '80%' : '60%'"
          src="@/assets/TaktingLogo.svg" />
        <img v-else style="" :width="$i18n.locale === 'en' ? '80%' : '60%'" src="@/assets/TaktingLogoBlack.svg" />
        <TText style="margin-top: -3%" :text="getUser.first_name + ' ' + getUser.last_name" font_weight="600" size="25" />
      </div>
      <!-- @click="setPosition()" -->
      <!-- <div  class="widget" :style="`background-color: ${container.color}`" v-if="container.widget === 'logo'">one {{container.position}}</div> -->
      <!-- LOGLIST WIDGET -->
      <Widget v-else-if="container.widget === 'loglist'" title="Loglist" :badgecount="getDashboardLoglistBadgeCount">
        <template #widgetContentOne>
          <div v-if="getDashboardLoglistLatest.length" @click="$router.push({ name: 'UserHomeLoglist' })"
            style="display: flex; flex-direction: column; gap: 3px">
            <Loglist v-for="entry in getDashboardLoglistLatest" :key="`loglist${entry.id}`" :loglist_entry="entry" />
          </div>
          <div v-else style="height: 100%;display: flex;
               align-items: center;
               justify-content: center; ">
            <TText style="font-style: italic" value="no_latest_loglist_entities" align="center" large font_weight="400" />
          </div>

        </template>
      </Widget>

      <!-- Update -->
      <Widget v-else-if="container.widget === 'update'">
        <template #widgetContentOne>
          <UpdatedWidget :last_login="getUser.updated" :image_count="getDashboardImagesLatest.length"
            :invite_count="getProjectInvites.length" :loglist_count="getDashboardLoglistLatest.length" />
        </template>
      </Widget>

      <!-- INVITATIONS WIDGET -->
      <Widget v-else-if="container.widget === 'invitations' && getProjectInvites.length" title="Invitations"
        :badgecount="getProjectInvites.length">
        <template #widgetContentOne>
          <div @click="$router.push({ name: 'UserHomeInvitations' })" style="display: flex; flex-direction: column">
            <Images v-for="entry in getProjectInvites" :key="`invitation${entry.id}`" :image="entry.project.image"
              :image_title="entry.name" icon="person" :footer_left="entry.prole"
              :footer_right="$t('Home.UserHome.Invitations.InvitedBy') + ' ' + entry.issuer" />
          </div>
        </template>
      </Widget>

      <!-- IMAGES WIDGET -->
      <Widget v-else-if="container.widget === 'images'" title="Images" :badgecount="getDashboardImagesBadgeCount">
        <template #widgetContentOne>
          <div v-if="getDashboardImagesLatest.length" @click="$router.push({ name: 'UserHomeImages' })"
            style="display: flex; flex-direction: column">
            <Images v-for="entry in getDashboardImagesLatest" :key="`images${entry.id}`" :image="entry.image"
              :image_title="entry.project_name" :footer_left="entry.user"
              :footer_right="entry.updated.substring(0, 16)" />
          </div>
          <div v-else style="height: 100%;display: flex;
               align-items: center;
               justify-content: center; ">
            <TText style="font-style: italic" value="no_latest_images" align="center" large font_weight="400" />
          </div>
        </template>
      </Widget>

      <!-- INVITES WIDGET -->
      <Widget v-else-if="container.widget === 'invite'" title="Invitations" :badgecount="getDashboardImagesBadgeCount">
        <template #widgetContentOne>
          <div @click="$router.push({ name: 'UserHomeInvitations' })">
            <StandardCard v-for="(invitation, index) in getProjectInvites" :key="'invite' + invitation.id"
              :image="invitation.project.image" :name="invitation.project.name" :cols="12">
              <template #info v-if="index <= 1">
                <div class="UserHome-invitationcard-title" style="
                display: flex;
                justify-content: space-between;
                margin-right: 2px;
                ">
                  <p style="margin-bottom: 0px; padding: 3px;"><v-icon color="primary">person</v-icon>
                    {{ invitation.prole }}
                  </p>
                  <p style="margin-bottom: 0px; padding: 3px;"> {{ $t("Home.UserHome.Invitations.InvitedBy") }} {{
                    invitation.issuer }} </p>

                  <div class="ml-2 craftsman-workpackages" v-if="false">

                    <TWorkPackage v-for="wp in invitation.work_packages" :key="`wp${wp.id}`" :workpackage_count="1"
                      :workpackage="wp" :color="wp.color">
                      <template #workpackage>
                        <StandardBadge :text="wp.count" color="white" content_color="black" />
                      </template>
                    </TWorkPackage>

                  </div>
                </div>
              </template>
            </StandardCard>
          </div>
        </template>
      </Widget>

      <!-- COMMUNITY WIDGET -->
      <Widget v-else-if="container.widget === 'community'" title="Community" :scrollable="false" :content_split="true">
        <template #widgetContentOne>
          <div style="height: 100%" @click="$router.push({
            name: 'WorkBenchSequences',
            params: {
              template_type: 'community',
              sfolder: 'last-updated'
            }
          })">
            <HomeDashboardCommunitySequences>
              <template #home_dashboard_community_sequences_header>
                <TText value="Sequences" font_weight="500" large />
              </template>
              <template #home_dashboard_community_sequence_body>
                <div>
                  <SequencePicker class="pb-5" v-for="sequence in getCommunityLatest.sequences"
                    :key="`sequence${sequence.id}`" :overflow_hidden="true">
                    <template #header>
                      <div class="mr-2">
                        {{ sequence.name }}
                      </div>
                    </template>
                    <template #subheader>
                      <div class="mt-2">

                        {{ sequence.owner.first_name }}
                        {{ sequence.owner.last_name }}
                        {{ sequence.created.substring(0, 10) }}
                      </div>
                    </template>
                    <template #sequence>
                      <TrainHead :zoom="0.4" style="flex-shrink: 0" />
                      <v-hover v-for="waggon in sequence.waggons" :key="`waggon${waggon.id}`">
                        <template #default="hover_waggon_slot">
                          <Waggon :zoom="0.4" :workpackage_count="waggon.work_packages.length" :style="
                            `transition: margin-right 0.1s ease-in-out;
                                                    margin-right: ${hover_waggon_slot.hover ? '0px' : '-10px'}
                                                    `
                          ">
                            <template #content>
                              <WorkPackage v-for="work_package in waggon.work_packages"
                                :key="`workpackage${work_package.id}`" :workpackage_count="waggon.work_packages.length"
                                :color="work_package.color" :zoom="0.4" />
                            </template>
                          </Waggon>
                        </template>
                      </v-hover>
                      <TrainTail :zoom="0.4" style="flex-shrink: 0" />
                    </template>
                  </SequencePicker>
                </div>
              </template>
            </HomeDashboardCommunitySequences>
          </div>
        </template>
        <template #widgetContentTwo>
          <div style="height: 100%" @click="$router.push({ name: 'ConnectCommunityWorkPackages' })">
            <HomeDashboardCommunityPackages>
              <template #home_dashboard_community_packages_header>
                <TText value="Packages" font_weight="500" large />
              </template>
              <template #home_dashboard_community_packages_body>
                <StandardCommunityPackage v-for="workpackage in getCommunityLatest.work_packages"
                  :key="`${workpackage.template_type}${workpackage.id}`" :color="workpackage.color"
                  :text_color="workpackage.textcolor" :zoom="0.4">
                  <template #header>
                    {{ workpackage.name }}
                  </template>
                  <template #content>
                    <div style="display: flex; flex-direction: row">
                      <TIcon :name="getNewIcon(workpackage.icon)" :color="workpackage.textcolor" /> {{ workpackage.token }}
                    </div>
                  </template>
                  <template #footer>
                    <div style="font-size: 11px">{{ workpackage.owner.first_name }} {{ workpackage.owner.last_name }}</div>
                  </template>

                </StandardCommunityPackage>
              </template>
            </HomeDashboardCommunityPackages>
          </div>
        </template>
      </Widget>

      <!-- QR-Code -->
      <Widget v-else-if="container.widget === 'qrcode'" title="QR.code">
        <template #widgetContentOne>
          <v-btn v-if="!show_scanner" @click="show_scanner = true" icon x-large color="black">
            <TIcon name="qr-code" />
          </v-btn>
          <div class="qr-scanner" v-if="show_scanner">
            <qrcode-stream @decode="onDecode"></qrcode-stream>
            <v-btn @click="show_scanner = false" icon x-large color="black">
              <TIcon name="close" />
            </v-btn>
          </div>
        </template>
      </Widget>

      <!-- WARNINGS -->
      <Widget v-else-if="container.widget === 'warnings'" style="" widget_color="var(--v-color-1-base)" title="WARNINGS">
        <template #widgetContentOne>
          <p> </p>
        </template>
      </Widget>

      <!-- NOTIFICATIONS -->
      <Widget v-else-if="container.widget === 'notifications'" style="" widget_color="var(--v-color-1-base)"
        title="NOTIFICATIONS">
        <template #widgetContentOne>
          <div style="height: 100%" class="userhome-scroll-animation">
            <article style="padding: 3px" v-for="article in getLatestNews" :key="'article' + article.id">
              <h2>{{ article.headline }}</h2>
              <p v-html="article.text"></p>
              <hr style="background: #333; border: none; color: #333; height: 1px; margin-left: 3%; margin-right: 3%">
            </article>
          </div>
        </template>
      </Widget>
    </div>
  </div>
</template>
<script>
import {
  mapGetters, mapActions
} from 'vuex';
import { UserHomeMixin } from '@/mixins/UserHome.mixin.js'
import store from '@/store/index'
import Images from '@/components/HomeDashboard/Widgets/HomeDashboardImagesWidget.component.vue'
import Loglist from '@/components/HomeDashboard/Widgets/HomeDashboardLoglistWidget.component.vue'
import Widget from '@/components/HomeDashboard/WidgetTemplate/Widget.component.vue'
import TIcon from '@/components/Taktify/TIcon.component.vue'
import TText from '@/components/Taktify/TText.component.vue'

import UpdatedWidget from '@/components/HomeDashboard/Widgets/HomeDashboardUpdateWidget.component.vue'

import HomeDashboardCommunityPackages from '@/components/HomeDashboard/Widgets/HomeDashboardCommunityPackages.component.vue'
import HomeDashboardCommunitySequences from '@/components/HomeDashboard/Widgets/HomeDashboardCommunitySequences.component.vue'
import StandardCommunityPackage from '@/components/HomeDashboard/Widgets/StandardCommunityPackage.component.vue'
import StandardCard from '@/components/StandardComponents/StandardCard.component.vue'
import SequencePicker from '@/components/ProjectTaktPlan/SequencePicker.component.vue'
import TrainHead from '@/components/ProjectTaktPlan/TrainHead.component.vue';
import Waggon from '@/components/ProjectTaktPlan/Waggon.component.vue';
import WorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
import TrainTail from '@/components/ProjectTaktPlan/TrainTail.component.vue';
// import HomeWidget from '@/components/Home/HomeWidget.component.vue'
// import HomeRegistrationWidget from '@/components/Home/HomeRegistrationWidget.component.vue'
// import HomeSocial from '@/components/Home/HomeSocial.component.vue'
export default {
  props: [],
  components: {
    Images,
    Widget,
    Loglist,
    HomeDashboardCommunityPackages,
    HomeDashboardCommunitySequences,
    StandardCommunityPackage,
    SequencePicker,
    TrainHead,
    Waggon,
    WorkPackage,
    TrainTail,
    UpdatedWidget,
    StandardCard,
    TIcon,
    TText
    // HomeWidget,
    // HomeRegistrationWidget,
    // HomeSocial
  },
  mixins: [
    UserHomeMixin,
  ],
  beforeRouteEnter(to, from, next) {

    let calls = [
      store.dispatch('User/requestUserProjectInvites', store.getters['Auth/getUser'].id),
      store.dispatch('Community/requestLatestCommunityEntities'),
      store.dispatch('TaktNews/requestLatestNews'),
      store.dispatch('Dashboard/requestLatestImageEntities'),
      store.dispatch('Dashboard/requestLatestLoglistEntities'),
      store.dispatch('Message/requestMessagesCurrentUser')
    ];
    Promise.all(calls).then(() => {
      next();
    });
  },
  created() {
    let json = require('../../../package.json');
    this.version_number = json.version;
    setInterval(this.getNow, 1000);


  },
  data: function () {
    return {
      hashtags: '',
      waggon_large_dialog: false,
      work_packages_large: [],
      work_packages_large_index: 0,
      time: '',
      date: '',
      timestamp: '',

      loglist_target: '',
      loglist_action: '',
      show_scanner: false


    }
  },
  computed: {
    ...mapGetters('Auth', [
      'getUser',
      'hasPermission',
      'getUserId'
    ]),
    ...mapGetters('User', [
      'getProjectInvites'
    ]),
    ...mapGetters('TaktNews', [
      'getLatestNews'
    ]),
    ...mapGetters('Community', [
      'getCommunityLatest',
      'isLoading'
    ]),
    ...mapGetters('Dashboard', [
      'getDashboardImagesLatest',
      'getDashboardLoglistLatest',
      'getDashboardLoglistBadgeCount',
      'getDashboardImagesBadgeCount',

    ]),
  },

  methods: {
    ...mapActions('ProjectInvitation', [
      'acceptProjectInvite',
      'declineProjectInvite'
    ]),
    ...mapActions('Community', [
      'requestLatestCommunityEntities',
      'likeCommunitySequence',
      'unlikeCommunitySequence',
      'requestCommunitySequencesByHashtags',
      'requestCommunitySequences'
    ]),


    getNow() {
      const today = new Date();
      const day = today.getDate() < 10 ? '0' + today.getDate() : today.getDate();
      const month = (today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1);
      const year = today.getFullYear();
      const time = (today.getHours() < 10 ? '0' + today.getHours() : today.getHours()) + ':' + (today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes());
      const dateTime = day + '.' + month + '.' + year + ' ' + time;
      const date = day + '.' + month + '.' + year;
      this.date = date;
      this.time = time;
      this.timestamp = dateTime;
    },
    onDecode(decoded) {
      this.show_scanner = false;
      // https://www.takting.com/codes?code=4FB370FD86&signature=298ab15638a179c3a5b210d1fcad4df7185bdb3469bf92803fee53a8ae0f5fd117878f2dd3ed68926f47e1a25ab0c9ca51be16db534eeeeb3b83a03a4df19e42130a4046b990874c0be66e8d5b75909911abb7d83b8f22aeab331db79ba28dd25781d13c09ef59cdc2061e5d933d9738a38ab6b3c7f2b37a9ad6b06966729ceaca4f14d15d97709dc6cbbd532af892ab7921b54c7da4aa8bf000a74d6d6ac74213665b6ba4541a0843cb088d1a927d0f7d989b75991be46a58ea4048355848d069992bcd7d41466804a1f3c9864b0ede2f4bfde3d5b6eb3339cf3a3d6d7558a61a2d3ce8133526207639d04494a48273e2c46aef5faf87e5ca557f447cb13d70
      let index_code = decoded.indexOf('?code=');
      let query = decoded.substring(index_code);
      store.dispatch('Project/resolveTag', { query: query });

    }
  },

}
</script>
<style>
.home-register-button {
  /* border: solid 1px grey; */
  /* margin-top: 5px; */
  border-radius: 10px;
  width: calc(100% - 10%);
  text-align: center;
  font-size: 30px;
  background-color: grey;
  /* opacity: 0.7; */
}

.home {
  height: calc(100% - 78px) !important;
  /* width: calc(100% - 20px); */
  overflow-x: hidden;
  padding: 10px !important;
}

.home-dashboard-logo {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* border: solid 1px white; */
}

.widget {
  height: 100%;
  width: 100%;
  display: flex;
  border: solid 1px #999999;
  border-radius: 15px;
  /* background: linear-gradient(to bottom,rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.1),rgba(0, 0, 0, 1)); */
  /* opacity: 0.5; */
  /* justify-content: center; */
  /* align-items: center; */
}

.userhome-scroll-animation {
  transition: margin-top 7s linear;
}

.userhome-scroll-animation:hover {
  margin-top: -100%;
}

.image-logo {
  border: hidden;
  padding-top: 5%;
  background: url('~@/assets/TaktingLogo.svg') 0px 10px;
}

.image-training {
  background-size: 100%;
  background-position: center;
  background-image: url('~@/assets/TrainingFive.png');
  /* opacity: 0.5; */
  /* background: linear-gradient(to top, black 0%, white 50%); */
}

.image-app {
  background-size: 100%;
  background-position: top;
  background-image: url('~@/assets/TaktPlan.png');
}

.image-knowledge {
  background-size: 140%;
  background-position: center;
  background-image: url('~@/assets/KnowledgeOne.jpg');
}

.image-algorithmic-flow {
  background-size: 100%;
  background-position: center;
  background-image: url('~@/assets/AlgorithmicFlowThree.jpg');
}

.image-takt-power {
  background-size: 350%;
  background-position: center;
  background-image: url('~@/assets/stopwatch.jpg');
}

.image-linkedIn {
  background-size: 90%;
  background-position: right;
  background-image: url('~@/assets/LinkedIn.png');
}

.image-takt-news {
  background-size: 90%;
  background-position: center;
  background-color: white;
  background-image: url('~@/assets/TaktIngQRCode.jpg');
}

.image-workbench {
  background-size: 110%;
  background-position: center;
  background-image: url('~@/assets/Workbench.jpg');
}

.image-takt-partners {
  background-size: 150%;
  background-position: center;
  background-image: url('~@/assets/TaktPartners.jpg');
}

.image-takt-connection {
  background-size: 150%;
  background-position: center;
  background-image: url('~@/assets/TaktConnections.jpg');
}

.image-process-boards {
  background-size: 150%;
  background-position: center;
  background-image: url('~@/assets/ProcessBoardsOne.jpg');
}

.image-pikto-one {
  background-size: 80%;
  background-position: center;
  /* background-image: url('~@/assets/White_Workbench.svg'); */
  background-image: url('~@/assets/White_AI.svg');
}

.image-pikto-two {
  background-size: 80%;
  background-position: center;
  background-image: url('~@/assets/White_Workbench.svg');
  /* background-image: url('~@/assets/White_AI.svg'); */
}

.detail_slide-enter,
.detail_slide-leave-to {
  transform: translateY(100vh);
}

.detail_slide-enter-active,
.detail_slide-leave-active {
  transition: transform 0.2s ease-in-out;
}

.qr-scanner {
  border: 1px solid rgba(0, 0, 0, 0.25);
  height: 250px;
  border-radius: 4px;
  z-index: 15;
}
</style>
